import { loadStripe, Stripe } from '@stripe/stripe-js';
import { StripeElementsOptions } from '@stripe/stripe-js';

export const ENV_STRIPE_KEY = process.env.REACT_APP_STRIPE_KEY;

const stripePromises = new Map<string, Promise<Stripe | null>>();

/**
 * One promise per key and account. `<Elements>` keeps the first `stripe` it
 * gets and only warns "Unsupported prop change on Elements: You cannot change
 * the `stripe` prop after setting it." when a later render passes a new one.
 */
export const getStripePromise = (
  publishableKey: string,
  stripeAccount?: string,
): Promise<Stripe | null> => {
  const cacheKey = `${publishableKey}:${stripeAccount ?? ''}`;
  const cached = stripePromises.get(cacheKey);
  if (cached) {
    return cached;
  }

  const promise = loadStripe(
    publishableKey,
    stripeAccount ? { stripeAccount } : undefined,
  );
  stripePromises.set(cacheKey, promise);
  return promise;
};

const appearance: StripeElementsOptions['appearance'] = {
  theme: 'stripe',
  labels: 'floating',
};

export const stripeElementsOptions: StripeElementsOptions = {
  appearance,
};

/**
 * Elements options for the wallet checkout flow (ENG-7890). `ExpressCheckoutElement`
 * + `stripe.confirmSetup` require the provider to be created in `setup` mode with a
 * currency (no `clientSecret`, since the SetupIntent is created on demand in the
 * confirm handler). Kept separate from `stripeElementsOptions` so the card mounts
 * remain unaffected.
 */
export const getWalletSetupElementsOptions = (
  currency: string,
): StripeElementsOptions => ({
  mode: 'setup',
  currency: currency.toLowerCase(),
  appearance,
});
